import { defineStore } from 'pinia';
import { getAddRankScore } from '@/api/point';

interface PointPurchaseState {
  scoreList: API.RankScoreResultItem[]
  money: number
  score: number
}

export const usePointPurchase = defineStore({
  id: 'seller-point-purchase',
  state: (): PointPurchaseState => ({
    scoreList: [],
    money: 0,
    score: 0,
  }),
  getters: {},
  actions: {
    async getAddRankScoreAction() {
      return getAddRankScore({ list: [1000, 1500, 2000, 2500, 3000] }).then((data) => {
        this.scoreList = data;
        this.money = data[0].money;
        this.score = data[0].add_score;
      });
    },
    async customiseMoney(money: number) {
      return getAddRankScore({ list: [money] }).then((data) => {
        this.money = data[0].money;
        this.score = data[0].add_score;
      });
    },
  },
});
